import { WhereClausePreview } from '@modules/common/components/WhereClausePreview';
import { isEmptyWhereClause } from '@modules/common/utils';
import { useFeedStore } from '@modules/feed/store/feedStore';
import { Grid, Typography, alpha } from '@mui/material';

export const FeedFilterDefinitionInfo = () => {
  const searchQuery = useFeedStore(({ query }) => query);

  const whereClause = searchQuery.whereClause;

  const isWhereClauseEmpty = !whereClause || isEmptyWhereClause(whereClause);

  const renderWhereClause = () => {
    if (isWhereClauseEmpty) {
      return 'No filters applied';
    }

    return (
      <WhereClausePreview
        shouldHideTooltips
        whereClause={whereClause}
        sxProps={{
          backgroundColor: (theme) =>
            alpha(theme.palette.background.paper, 0.8),
        }}
      />
    );
  };

  return (
    <>
      <Grid item xs={3}>
        <Typography variant="caption" color="inherit">
          Filter By:
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Typography variant="caption" color="inherit">
          {renderWhereClause()}
        </Typography>
      </Grid>
    </>
  );
};
